import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';

const API_URL = process.env.REACT_APP_BACKEND_URL;
const SESSION_KEY = 'gpk_sid';

function getSessionId() {
  let sid = sessionStorage.getItem(SESSION_KEY);
  if (!sid) {
    sid = crypto.randomUUID ? crypto.randomUUID() : Math.random().toString(36).slice(2) + Date.now().toString(36);
    sessionStorage.setItem(SESSION_KEY, sid);
  }
  return sid;
}

export default function usePageTracker() {
  const location = useLocation();
  const lastPath = useRef('');

  useEffect(() => {
    const path = location.pathname + location.search;
    if (path === lastPath.current) return;
    lastPath.current = path;

    // Skip admin pages
    if (path.startsWith('/admin')) return;

    const sid = getSessionId();
    const payload = {
      page: path,
      referrer: document.referrer || '',
      session_id: sid,
    };

    // Fire and forget — don't block rendering
    fetch(`${API_URL}/api/site-analytics/track`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload),
    }).catch(() => {});
  }, [location]);
}
